export const aboutData = {
  brandName: '安全指南',
  tagline: '理性认知 · 安全为先 · 法律至上',
  introduction: `"安全指南"是一个致力于提供网络信息安全与合规知识的教育平台。我们的团队由信息安全专家、法律顾问和数字素养教育者组成，旨在帮助成年用户建立科学的网络使用观念，掌握必要的安全防护技能。

我们坚信，知识是最好的防护武器。在一个信息日益复杂的数字世界中，每个人都有权获得准确、客观、实用的安全知识。我们的内容坚持以事实为依据、以法律为准绳，力求在专业性和可读性之间找到最佳平衡。

自平台成立以来，我们已发布数十篇深度文章，帮助数以万计的用户提升了网络安全素养。我们将继续在这个领域深耕，为构建更加安全、理性的网络环境贡献力量。`,

  stats: [
    { label: '深度文章', value: '34+', icon: 'ri-article-line' },
    { label: '内容分类', value: '6', icon: 'ri-folder-line' },
    { label: '覆盖主题', value: '50+', icon: 'ri-lightbulb-line' },
    { label: '持续运营', value: '3年+', icon: 'ri-time-line' },
  ],

  values: [
    {
      title: '客观中立',
      description: '我们坚持基于事实和法律的分析，不带有偏见和主观判断，为用户提供客观可靠的信息参考。',
      icon: 'ri-scales-3-line',
    },
    {
      title: '用户至上',
      description: '用户的安全和隐私始终是我们的首要关切。我们的所有内容都以保护用户利益为出发点。',
      icon: 'ri-user-heart-line',
    },
    {
      title: '知识赋能',
      description: '我们相信信息的力量。通过提供系统化的安全知识，帮助用户建立自我保护的能力。',
      icon: 'ri-brain-line',
    },
    {
      title: '法律底线',
      description: '所有内容严格遵守法律法规，坚决维护法律底线，倡导合法合规的网络使用行为。',
      icon: 'ri-auction-line',
    },
  ],

  contact: {
    email: 'contact@safety-guide.example.com',
    response: '我们通常在1-2个工作日内回复您的咨询。',
    disclaimer: '本网站提供的信息仅供教育和参考目的，不构成法律或专业技术建议。如有具体问题，请咨询相关领域的专业人士。',
  },
};